// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".go-back-icon-button[data-v-0d29f6d2]{border:none;background:rgba(0,0,0,0);padding:0;outline:none}", ""]);
// Exports
module.exports = exports;
